export default function (ModalService) {
    return function () {
        return ModalService.showModal({
            controller: require('../../controllers/add/addAccountGroupCtrl'),
            template: require('../../controllers/add/addAccountGroup.html'),
            controllerAs: 'addGroup'
        });
    };
}



// WEBPACK FOOTER //
// ./Client/app/accountGroups/services/add/openAddAccountGroupModal.js